import XIcon from "~/assets/svg/x.svg?component";
import draggable from "vuedraggable";
import { PlusIcon, TransformIcon } from "vue-tabler-icons";
import { useNotification } from "@kyvg/vue3-notification";
const { notify } = useNotification();
export default defineComponent({
  components: { XIcon, PlusIcon, draggable, TransformIcon },
  data() {
    const config = useRuntimeConfig();
    const loading: boolean = false;
    const files: Array<{
      filename: string;
      path: string;
      originalname?: string;
      size?: number;
      publicId?: string;
    }> = [];
    const drag: boolean = false;
    const percentage: number = 0;
    return {
      type: "images",
      files,
      loading,
      percentage,
      config,
      drag,
    };
  },
  methods: {
    clearSession() {
      this.files = [];
    },
    async UploadFiles(formdata: FormData, multiple = false, type = "") {
      this.loading = true;
      this.percentage = 0;
      const xhr = new XMLHttpRequest();
      var url = this.config.public.app_nest_url + "/cloud/" + this.type;
      if (type) {
        url = this.config.public.app_nest_url + "/cloud/" + type;
      }
      xhr.open("POST", url, true);
      xhr.upload.onprogress = (e) => {
        if (e.lengthComputable) {
          this.percentage = (e.loaded / e.total) * 100;
        }
      };
      xhr.onreadystatechange = () => {
        
        if (xhr.readyState == 4) {
          this.loading = false;
          if (!xhr.status) {
            notify({
              type: "error",
              text: "Unable to connect to server. Please try again",
            });
            console.log("Unable to connect to server. Please try again");
          }
        }
      };
      xhr.onload = () => {
        if (xhr.status === 201) {
          if (multiple) {
            this.files = [...this.files, ...JSON.parse(xhr.responseText)];
          } else {
            this.files = [JSON.parse(xhr.responseText)];
          }
          this.loading = false;
        } else {
          this.loading = false;
          const response: { message: string } = JSON.parse(xhr.responseText);
          notify({
            text: response.message,
            type: "error",
          });
        }
      };
      xhr.send(formdata);
    },
    async DeleteFile(file: { filename: string; publicId?: string }) {
      this.files = this.files?.filter((item) => item.publicId != file.publicId);
      if (file.publicId) {
        $fetch(this.config.public.app_nest_url + "/cloud/file", {
          method: "DELETE",
          body: { publicId: file.publicId },
        });
      }
    },
    ValidateSizeFile(file: File, limit: number) {
      if (file.size > limit * 1024 * 1024) {
        return false;
      }
      return true;
    },
  },
});
